import React, { useState } from 'react'
import Dialog from '../../../../common/element/Dialog'
import BtnLight from "../../../../common/element/Buttons/btnLight";
import { Link, useNavigate } from 'react-router-dom'

const ExpiredSubscription = (props) => {
    const navigate = useNavigate();

    const onAddDialogClose = () => {
        props?.setSubscriptionDialogOpen(false)
        // localStorage.removeItem("conserve_authtoken");
        // localStorage.setItem("checkAuth", JSON.stringify(""));
        // navigate("/login")
    }
    return (
        <div className='subscription-cstm'>
       
                <div className="px-6 pt-6" >
                    {/* <span className="w-12 h-12 rounded-full m-auto bg-success-100 flex items-center justify-center">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="49"
                            height="49"
                            viewBox="0 0 49 49"
                            fill="none"
                        >
                            <rect
                                x="0.583008"
                                y="1.37207"
                                width="47"
                                height="47"
                                rx="23.5"
                                fill="#D1FADF"
                            />
                            <rect
                                x="0.583008"
                                y="1.37207"
                                width="47"
                                height="47"
                                rx="23.5"
                                stroke="#ECFDF3"
                            />
                            <path
                                d="M32.083 18.8721L21.083 29.8721L16.083 24.8721"
                                stroke="black"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </span> */}
                    <p className="text-base text-gray-900 font-semibold text-center mt-4">
                        Your organisation's subscription has expired.
                         {/* Please renew your subscription plan. */}
                    </p>
                </div>
                {/* <div className="mt-8 flex justify-between pb-6 px-6">
                    <BtnLight onClick={() => onAddDialogClose()}>Close</BtnLight>
                </div> */}
          
        </div>
    )
}

export default ExpiredSubscription
